/* eslint-disable no-unreachable */
/* eslint-disable no-underscore-dangle */
// @ts-nocheck
/* eslint-disable react/destructuring-assignment */
import { DeleteOutlined, MailOutlined, MoreOutlined, SearchOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Avatar,
  Button,
  Checkbox,
  Collapse,
  Drawer,
  Dropdown,
  Empty,
  Form,
  Image,
  Input,
  Layout,
  Menu,
  message,
  Modal,
  Select,
  Skeleton,
  Spin,
  Splitter,
  Switch,
  Table,
  Tooltip,
} from "antd";
import dayjs from "dayjs";
import { capitalize, isEmpty, sumBy } from "lodash";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { UserContext } from "../../../amplify/authenticator-provider";
import {
  CREATE_EMAIL,
  DELETE_COMPANY_EMAIL_TEMPLATE_EVENT,
  DELETE_DRAFT,
  DELETE_ENAGEMENT_MESSAGE_TEMPLATE,
  DELETE_SCHEDULED_EMAIL,
  SAVE_ENAGEMENT_MESSAGE_TEMPLATE,
  UPDATE_COMPANY_EMAIL_TEMPLATE_EVENT,
  UPDATE_EMAIL_STATUS,
} from "../../../graphql/mutation";
import {
  GET_COMPANY_EMAIL_TEMPLATE_EVENT,
  GET_DRAFTS,
  GET_EMAIL_THREAD,
  GET_EMAILS,
  GET_ENGAGEMENT_MESSAGE_TEMPLATES,
  GET_SCHEDULED_EMAILS_FOR_LOCATION,
  GET_LEAD_DETAIL_CLICK,
} from "../../../graphql/query";
import DeleteIcon from "../../../icons/js/DeleteIcon";
import LinkIcon from "./icons/LinkIcon";
import {
  AlarmClock,
  DraftIcon,
  EmailIcon,
  EmailTemplate,
  InboxIcon,
  SendScheduleIcon,
} from "../../../icons/js/EmailIcons";
import { EditPencilIcon } from "../../../icons/js/PencilIcon";
import { RemainderIcon21 } from "../../../icons/js/RemainderIcon";
import RestoreArchiveIcon from "../../../icons/js/RestoreArchive";
import SendIcon from "../../../icons/js/SendIcon";
import { convertUtcToLocal, formatBytes } from "../../../library/utils";
import { setTextMode, setSelectedLeadRedux } from "../../../redux/slices/leadSlice";
import { s3uploader } from "../../../utils/awsS3MediaUploader";
import { generateVideoThumbnails } from "../../../utils/videoThumbnailGenerator";
import { convertToInitials } from "../../layoutComponent/layoutHelpers";
import Attachments from "./attachments";
import { EmailBottomActions } from "./EmailBottomActions";
import { EmailList } from "./emailComponents/EmailList";
import { ThreadsJSX } from "./emailComponents/ThreadEmail";
import { setForwardMessage, setReplyMessage } from "./emailMockData";
import { EmailTextBox } from "./EmailTextBox";
import { handleFiles } from "./engagementActivity";
// import { INBOX_ICON } from "../../../config";
import INBOX_ICON from "../../../icons/svg/inboxIcon.svg";
import SEND_ICON from "../../../icons/svg/sentIcon.svg";
import SCHEDULED_ICON from "../../../icons/svg/scheduledIcon.svg";
import DRAFT_ICON from "../../../icons/svg/draftIcon.svg";
import TRASH_ICON from "../../../icons/svg/trashIcon.svg";
import EMAIL_TEMPLATE_ICON from "../../../icons/svg/emailTemplateIcon.svg";
import INBOX_ICON_1 from "../../../icons/svg/inbox-icon.svg";
import CLOCK_ICON from "../../../icons/svg/clock.svg";
import { cleanHtmlForPreview } from "../../../utils/htmlHelpers";
import ViewOnlyEmail from "./emailComponents/ViewOnlyEmail";
import {
  EMAIL_FORWARDING_PREFIX,
  EMAIL_REPLY_PREFIX,
  TEMPLATE_ENUMS,
} from "../../../constant/EmailConstant";
import DebounceInput from "../../commonComponents/DebounceInput";
import { getValidEmail, removeEmailPrefixesAndAddNew } from "./engagementHelpers";
import { smartPrepend } from "../../../utils";

const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");

dayjs.extend(relativeTime);
dayjs.extend(utc);

const { Sider, Content } = Layout;

/**
 * @typedef {Object} Threads
 * @property {string} fromEmail
 * @property {string} imgUrl
 * @property {string} fromName
 * @property {string} toEmail
 * @property {string} toName
 * @property {string} emailBody
 * @property {string} timeStamp
 * @property {boolean} [scheduled]
 *
 */

// @ts-ignore
// @ts-ignore
export const Emails = props => {
  const [emailKey, setemailKey] = useState("inbox");
  const [selectedEmail, setselectedEmail] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [scheduleEmailCancelModal, setscheduleEmailCancelModal] = useState({
    visible: false,
    id: null,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTextMode("Email"));
  }, []);
  const menuItems = [
    {
      label: "Inbox",
      icon: (
        <Image
          width={15}
          className={emailKey === "inbox" ? "icon-active" : "icon-inactive"}
          preview={false}
          src={INBOX_ICON}
          alt="Inbox"
        />
      ),
    },
    {
      label: "Sent",
      icon: (
        <Image
          width={15}
          className={emailKey === "sent" ? "icon-active" : "icon-inactive"}
          preview={false}
          src={SEND_ICON}
          alt="Sent"
        />
      ),
    },
    {
      label: "Scheduled",
      icon: (
        <Image
          width={17}
          className={emailKey === "scheduled" ? "icon-active" : "icon-inactive"}
          preview={false}
          src={SCHEDULED_ICON}
          alt="Scheduled"
        />
      ),
    },
    {
      label: "Drafts",
      icon: (
        <Image
          width={17}
          className={emailKey === "drafts" ? "icon-active" : "icon-inactive"}
          preview={false}
          src={DRAFT_ICON}
          alt="Drafts"
        />
      ),
    },
    {
      label: "Trash",
      icon: (
        <Image
          width={15}
          className={emailKey === "trash" ? "icon-active" : "icon-inactive"}
          preview={false}
          src={TRASH_ICON}
          alt="Trash"
        />
      ),
    },
    {
      label: "Email Template",
      icon: (
        <Image
          width={17}
          className={emailKey === "email template" ? "icon-active" : "icon-inactive"}
          preview={false}
          src={EMAIL_TEMPLATE_ICON}
          alt="Email Template"
        />
      ),
    },
  ];
  const [refetchEmailFn, setRefetchEmailFn] = useState(null);

  const [getLeadDetail, { loading: leadClickLoader }] = useLazyQuery(GET_LEAD_DETAIL_CLICK);

  useEffect(() => {
    if (leadClickLoader) {
      message.loading("Fetching lead details, please wait");
    }
  }, [leadClickLoader]);

  // This callback will be passed to EmailList
  const refetchEmailListFn = cb => {
    setRefetchEmailFn(() => cb);
  };

  const refetchEmailList = () => {
    if (refetchEmailFn) {
      // @ts-ignore
      refetchEmailFn();
    }
  };
  // useEffect(() => {
  //   socket.on("received_message",())
  // }, []);
  //   border-[0px] border-b border-r border-grey-200 border-solid
  const emailListProps = {
    emailKey,
    setemailKey,
    setselectedEmail,
    selectedEmail,
    scheduleEmailCancelModal,
    setscheduleEmailCancelModal,
    refetchEmailListFn,
  };
  const viewEmailProps = {
    selectedEmail,
    setselectedEmail,
    scheduleEmailCancelModal,
    setscheduleEmailCancelModal,
    refetchEmailListFn: refetchEmailList,
    onClickLead: async lead => {
      const res = await getLeadDetail({
        variables: {
          leadId: lead?.id,
        },
      });
      props?.onRowClick({
        data: { ...(res?.data?.lead || {}) },
        tab: "activity-center",
        firstLeadSet: true,
      });
      window.history.pushState("", "", `/engagements/activity-center`);
    },
  };
  useEffect(() => {
    const element = document.getElementsByClassName("engagementActivityTab")[0];
    if (element) {
      element.classList.add("overflow-y-hidden");
    }
    return () => {
      element.classList.remove("overflow-y-hidden");
    };
  }, []);
  const render = () => {
    switch (emailKey) {
      case "scheduled":
        return (
          <ScheduledJSX
            scheduleEmailCancelModal={scheduleEmailCancelModal}
            setscheduleEmailCancelModal={setscheduleEmailCancelModal}
          />
        );
      case "drafts":
        return <DraftsJSX />;
      case "trash":
        return <TrashJSX />;
      case "email_template":
        return <EmailTemplateJSX />;
      default:
        return (
          <div className="w-full h-full flex">
            <Splitter className="w-full h-full">
              <Splitter.Panel defaultSize="28%" min="23%" max="40%" className="overflow-auto">
                <EmailList {...emailListProps} />
              </Splitter.Panel>
              <Splitter.Panel defaultSize="72%" className="overflow-auto">
                <ViewEmail {...viewEmailProps} />
              </Splitter.Panel>
            </Splitter>
          </div>
        );
    }
  };

  return (
    <Layout className="h-screen">
      <Sider
        className="bg-white emails-sider border border-t-0 border-grey-200 border-solid"
        collapsible
        collapsed={collapsed}
        onCollapse={value => setCollapsed(value)}
      >
        <div
          className={`p-4 border-0 border-b border-solid border-grey-200 flex-row-centered gap-2 items-center ${
            collapsed && "justify-center"
          } `}
        >
          <span className="text-grey-700 text-base font-[600]">Email</span>
        </div>
        <Menu
          theme="light"
          className="border-r-0"
          defaultSelectedKeys={[emailKey]}
          onSelect={info => setemailKey(info.key)}
          items={menuItems.map(item => ({
            key: item.label.toLowerCase().replace(" ", "_"),
            label: !collapsed && (
              <span
                className={`ml-2 ${
                  emailKey === item.label.toLowerCase().replace(" ", "_")
                    ? "font-medium"
                    : "font-normal"
                }`}
              >
                {item.label}
              </span>
            ),
            icon: item.icon,
            title: item.label, // Add title for tooltip
          }))}
        />
      </Sider>
      <Content className="bg-white ">
        <div className="flex flex-row h-screen w-full">{render()}</div>
      </Content>
    </Layout>
  );
};

/**
 *
 * @param {string} date
 * @param {string?} format
 * @returns
 */
export const dateFromNow = (date, format = "MM/DD/YYYY") => {
  const localTime = dayjs.utc(date).local();
  const now = dayjs();

  const diffInDays = now.diff(localTime, "day");

  return diffInDays <= 5 ? localTime.fromNow() : localTime.format(format || "MM/DD/YYYY");
};

/**
 *
 * @param {{selectedEmail:import("./emailMockData").EmailsData | null,setselectedEmail:import("react").Dispatch<import("react").SetStateAction<import("./emailMockData").EmailsData | null>>,setscheduleEmailCancelModal:import("react").Dispatch<import("react").SetStateAction<boolean>>,refetchEmailListFn:()=>any}} props
 * @returns
 */
const ViewEmail = props => {
  const { selectedEmail, onClickLead } = props;
  /**
   * @type {[import("./emailMockData").EmailsData[],import("react").Dispatch<import("react").SetStateAction<import("./emailMockData").EmailsData[]>>]}
   */
  // @ts-ignore
  const [emails, setemails] = useState([]);
  const {
    data,
    loading: emailsLoader,
    refetch: refetchEmails,
  } = useQuery(GET_EMAIL_THREAD, {
    fetchPolicy: "network-only",
    skip: !selectedEmail?.sesMessageId, // Skip the query if no selected email or no sesMessageId
    variables: {
      rootSesMessageId: selectedEmail?.sesMessageId,
      orderDirection: "asc",
    },
    /**
     *
     * @param {{getEmailThread:{data:import("./emailMockData").EmailsData[]}}} res
     */
    onCompleted: res => {
      setemails(res.getEmailThread.data);
    },
  });
  const refetchEmailFunction = async () => {
    const res = await refetchEmails({
      variables: {
        rootSesMessageId: selectedEmail?.sesMessageId,
      },
    });
    if (res) {
      // @ts-ignore
      setemails(res.data.getEmailThread.data);
    }
  };
  return !isEmpty(selectedEmail) ? (
    <div className="h-full">
      <div className="flex-row-centered gap-6 px-5 py-1.5 border-0 border-b border-solid border-grey-200">
        <div className="flex-col-centered gap-1">
          <span className="font-semibold text-[14px] flex items-center gap-1">
            {selectedEmail?.lead?.fullName}
            <Tooltip title="Open in activity center">
              <span
                className="sm-400 text-grey-700 cursor-pointer mt-1"
                onClick={() => {
                  onClickLead(selectedEmail?.lead);
                }}
              >
                <LinkIcon />
              </span>
            </Tooltip>
          </span>

          <span className="text-[14px] font-normal">Subject: {selectedEmail?.subject}</span>
        </div>
      </div>
      <Skeleton loading={emailsLoader} active paragraph={{ rows: 3 }} avatar>
        <div className="email-scroll-container">
          {emails.map((thread, index) => (
            <div key={thread.id} className="w-full min-h-min">
              {/* @ts-ignore */}
              <ThreadsJSX
                setscheduleEmailCancelModal={props.setscheduleEmailCancelModal}
                thread={thread}
                index={index}
                selectedEmail={selectedEmail}
                refetchEmails={refetchEmailFunction}
                refetchEmailListFn={props.refetchEmailListFn}
              />
              <div className="w-full h-0.5 bg-grey-200" />
            </div>
          ))}
        </div>
      </Skeleton>
    </div>
  ) : (
    <Empty description="Select a mail" />
  );
};

/**
 *
 * @param {{showReply:{visible:boolean,email:string,id:null | string,showSubject: boolean,mode:"Reply" | "Forward",emailData:import("./emailMockData").EmailsData | null},setshowReply:import("react").Dispatch<import("react").SetStateAction<{visible:boolean,email:string}>>,selectedLead:any,emailForm:import("antd").FormInstance<any>,createEmail:()=>Promise<any>,selectedEmail:import("./emailMockData").EmailsData,refetchEmails:()=>any,refetchEmailListFn:()=>any,mediaUploadLoader:boolean, setMediaUploadLoader:import("react").Dispatch<import("react").SetStateAction<boolean>>}} props
 * @returns
 */
export const ReplyEmail = props => {
  // @ts-ignore
  // @ts-ignore
  const { setshowReply, selectedLead, selectedEmail } = props;
  const { user } = useContext(UserContext);
  // @ts-ignore
  const [mmsLoader, setmmsLoader] = useState(false);
  const emailTextRef = useRef(null);
  const [attachments, setattachments] = useState([]);
  const [email, setemail] = useState(props.showReply.email);
  /**
   *
   * @param {string} files
   * @param {string} fileType
   * @returns
   */
  const fetchData = async (files, fileType) => {
    // @ts-ignore
    if (fileType.includes("video" || "quicktime")) {
      try {
        const response = await generateVideoThumbnails(files, 2);
        // setVideoThumbnails(response[0]);
        const thumbnailUrl = await s3uploader(
          response,
          process.env.GATSBY_S3_BUCKET,
          // @ts-ignore
          // @ts-ignore
          state => {},
          true,
          sessionStorage.getItem("currentLocationId")?.includes(",")
            ? "all"
            : sessionStorage.getItem("currentLocationId"),
          user,
          selectedLead
        );
        // @ts-ignore
        return thumbnailUrl.url;
      } catch (e) {
        console.log("ReplyEmail:Unable to generate video thumbnails", e);
      }
    }
  };

  useEffect(() => {
    if (props.showReply.visible) {
      setTimeout(() => {
        if (props.showReply.mode === "Forward") {
          props.emailForm.setFieldValue(
            "subject",
            // @ts-ignore
            `${removeEmailPrefixesAndAddNew(
              props.showReply.emailData.subject,
              EMAIL_FORWARDING_PREFIX
            )}`
          );
          props.emailForm.setFieldValue("to", "");
          // @ts-ignore
          emailTextRef.current.innerHTML = setForwardMessage(props.showReply.emailData);
        } else if (props.showReply.mode === "Reply") {
          // @ts-ignore
          emailTextRef.current.innerHTML = setReplyMessage(props.showReply.emailData);
          props.emailForm.setFieldValue(
            "subject",
            // @ts-ignore
            `${removeEmailPrefixesAndAddNew(props.showReply.emailData.subject, EMAIL_REPLY_PREFIX)}`
          );
          props.emailForm.setFieldValue(
            "to",
            props?.isEmailModule
              ? props?.showReply?.emailData?.to
              : getValidEmail(props?.showReply?.email)
          );
          emailTextRef.current.focus();
        }
        setemail(props.showReply.email);
      }, 4 * 100);
    }
  }, [props.showReply.mode, props.showReply.emailData, props.showReply.visible]);

  const handleEmail = async (values, emailTextRef, emailTemplate) => {
    // @ts-ignore
    if (isEmpty(emailTextRef.current.innerText.replace(/\s/g, ""))) {
      return message.error("Please enter a body");
    }
    let mmsArr = [];
    if (attachments.length > 0) {
      setmmsLoader(true);
      // @ts-ignore
      mmsArr = await handleFiles(
        attachments,
        user,
        selectedLead,
        fetchData,
        props.setMediaUploadLoader
      );
      setmmsLoader(false);
    }
    // @ts-ignore
    let payload = {};
    if (props.showReply.mode === "Reply") {
      const { subject } = props.emailForm.getFieldsValue() || {};

      payload = {
        attachments: mmsArr,
        ...values,
        body: emailTextRef.current.innerHTML,
        ...props.emailForm.getFieldsValue(),
        replyToEmailId: props.showReply.id || null,
        content: emailTextRef.current.innerHTML,
        // @ts-ignore
        leadId: +(props?.showReply?.emailData?.lead?.id || selectedLead?.id),
        subject: `${removeEmailPrefixesAndAddNew(subject, EMAIL_REPLY_PREFIX)}`,
        userId: user?.id,
      };
    } else if (props.showReply.mode === "Forward") {
      const { subject } = props.emailForm.getFieldsValue() || {};

      payload = {
        attachments: mmsArr,
        ...values,
        body: emailTextRef.current.innerHTML,
        ...props.emailForm.getFieldsValue(),
        content: emailTextRef.current.innerHTML,
        subject: `${removeEmailPrefixesAndAddNew(subject, EMAIL_FORWARDING_PREFIX)}`,
        // @ts-ignore
        leadId: +(props?.showReply?.emailData?.lead?.id || selectedLead?.id),
        userId: user.id,
      };
    }

    // @ts-ignore
    const res = await props.createEmail({
      variables: payload,
    });
    if (res.data.createEmail.statusCode === 200) {
      message.success(res.data.createEmail.message);
      props.refetchEmails();
      props.refetchEmailListFn();
      setshowReply(
        // @ts-ignore
        { visible: false, email: "" }
      );
    } else {
      message.error(res.data.createEmail.message);
    }
  };

  return (
    <div className="flex-col-centered p-1 gap-1">
      <EmailTextWithBottom
        email={email}
        setemail={setemail}
        attachments={attachments}
        setattachments={setattachments}
        emailForm={props.emailForm}
        showSend={false}
        disableToEmail={!isEmpty(props.showReply.email)}
        handleEmail={handleEmail}
        emailTextRef={emailTextRef}
        className="h-[inherit]"
        showSubject={props.showReply.showSubject}
        leadId={props.showReply.emailData?.lead?.id}
        setEmailBody={value => {
          emailTextRef.current.innerHTML = value;
        }}
      />
    </div>
  );
};
/**
 *
 * @param {{scheduleEmailCancelModal:boolean,setscheduleEmailCancelModal:import("react").Dispatch<import("react").SetStateAction<boolean>>,emails:[import("./emailMockData").EmailsData],handleEdit:(email:import("./emailMockData").EmailsData)=>any,showBody?:boolean,showHeader?:boolean}} props
 * @returns
 */
export const ScheduledJSX = props => {
  const { showHeader = true } = props;
  const [scheduledEmails, setscheduledEmails] = useState(props.emails || []);
  const [scheduleEmailCancelModal, setscheduleEmailCancelModal] = useState({
    visible: false,
    id: null,
  });
  const [viewEmailDrawer, setViewEmailDrawer] = useState({ open: false, email: {} });
  const [scheduleEmailDrawer, setscheduleEmailDrawer] = useState({ open: false, email: {} });
  const [attachments, setattachments] = useState([]);
  const [emailForm] = Form.useForm();
  const handleEmail = (...rest) => {
    console.log(rest);
  };
  const emailTextRef = useRef(null);
  const dropDownMenu = email => {
    return [
      ...(props.handleEdit
        ? [
            {
              label: "Edit",
              icon: <EditPencilIcon color="black" />,
              key: "EDIT",
              onClick: e => {
                e.domEvent.stopPropagation();
                props.handleEdit
                  ? props.handleEdit(email)
                  : setscheduleEmailDrawer({ open: true, email });
              },
            },
          ]
        : []),
      {
        label: "Cancel Schedule",
        onClick: e => {
          e.domEvent.stopPropagation(); // Prevent outer click
          setscheduleEmailCancelModal({ visible: true, id: email.id });
        },
        icon: <AlarmClock />,
        key: "CANCEL_SCHEDULE",
      },
      // {
      //   label: "Delete",
      //   icon: <DeleteIcon size="20" />,
      //   key: "DELETE",
      //   danger: true,
      // },
    ];
  };
  const [
    getScheduledEmailsForLocation,
    { loading: getScheduledEmailsLoader, refetch: refetchScheduledEmails },
  ] = useLazyQuery(GET_SCHEDULED_EMAILS_FOR_LOCATION, {
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    if (props.emails) {
      setscheduledEmails(props.emails);
    } else {
      getScheduledEmailsForLocation({
        variables: {
          locationIds: sessionStorage
            .getItem("currentLocationId")
            .split(",")
            .map(i => +i),
        },
      }).then(res => {
        setscheduledEmails(res.data.getScheduledEmailsForLocation);
      });
    }
  }, [props.emails]);
  const [deleteScheduledEmail, { loading: deleteScheduledEmailLoader }] =
    useMutation(DELETE_SCHEDULED_EMAIL);
  const deleteSchedule = async () => {
    const res = await deleteScheduledEmail({
      variables: {
        id: scheduleEmailCancelModal.id,
        timezone: dayjs.tz.guess(),
      },
    });
    if (res.data.deleteScheduledEmail.statusCode === 200) {
      message.success(res.data.deleteScheduledEmail.message);
      const refetchRes = await refetchScheduledEmails();
      setscheduledEmails(refetchRes.data.getScheduledEmailsForLocation);
      setscheduleEmailCancelModal({ visible: false, id: null });
      setViewEmailDrawer({ open: false, email: {} });
    } else {
      message.error(res.data.deleteScheduledEmail.message);
    }
  };
  return (
    <div className="flex-col-centered w-full h-full">
      {showHeader && (
        <div className="flex-row-centered items-center gap-2 p-4 border-0 border-b border-solid border-grey-200">
          <SendScheduleIcon />
          <span>Messages in Scheduled will be sent at their scheduled time.</span>
        </div>
      )}
      <Skeleton active paragraph={{ rows: 4 }} loading={getScheduledEmailsLoader}>
        <div className={`email-scroll-container ${showHeader ? "" : "h-full"}`}>
          {scheduledEmails.map((email, index) => (
            <div
              key={index}
              className="w-full min-h-min cursor-pointer"
              onClick={() => setViewEmailDrawer({ open: true, email })}
            >
              <EmailCollapsedCard
                // @ts-ignore
                dropDownMenu={dropDownMenu(email)}
                timeStampIcon={<AlarmClock />}
                {...props}
                // @ts-ignore
                email={{ ...email, latestActivityTs: email.taskSendDatetime }}
                showBody={props.showBody || false}
              />
            </div>
          ))}
        </div>
      </Skeleton>
      <CancelScheduleConfirmation
        open={scheduleEmailCancelModal.visible}
        setOpen={value => setscheduleEmailCancelModal({ visible: value, id: null })}
        cancelText="No"
        okText="Yes, Cancel"
        description="Are you sure you want to cancel this scheduled mail? You can reschedule it anytime from Drafts."
        title="Cancel schedule mail?"
        onOk={() => deleteSchedule()}
        loading={deleteScheduledEmailLoader}
      />
      <Drawer
        width="40%"
        open={scheduleEmailDrawer.open}
        onClose={() => setscheduleEmailDrawer({ email: {}, open: false })}
      >
        <EmailTextWithBottom
          email={scheduleEmailDrawer.email.to}
          setemail={value => setscheduleEmailDrawer({ ...scheduleEmailDrawer, email: value })}
          attachments={attachments}
          body={scheduleEmailDrawer.email.body}
          setattachments={setattachments}
          emailForm={emailForm}
          disableToEmail={false}
          handleEmail={handleEmail}
          emailTextRef={emailTextRef}
          className="h-[58vh]"
        />
      </Drawer>
      <Drawer
        width="40%"
        open={viewEmailDrawer.open}
        onClose={() => setViewEmailDrawer({ email: {}, open: false })}
        title={`Scheduled send to ${viewEmailDrawer.email.to}`}
        zIndex={51} // Set a lower z-index for the drawer
      >
        <ViewOnlyEmail
          scheduled
          cancelScheduledCallback={emailId => {
            // Implement cancel schedule logic here
            setscheduleEmailCancelModal({ visible: true, id: emailId });
          }}
          email={viewEmailDrawer.email}
        />
      </Drawer>
    </div>
  );
};
const DraftsJSX = props => {
  const { user } = useContext(UserContext);
  const [deleteModal, setdeleteModal] = useState(false);
  const emailTextRef = useRef(null);
  const [emailForm] = Form.useForm();
  const [drafts, setDrafts] = useState({ drafts: [], count: 0 });
  const [draftMode, setDraftMode] = useState({
    email: "",
    visible: false,
    emailData: {},
  });
  const [attachments, setattachments] = useState([]);
  const dropDownMenu = [
    {
      label: "Edit",
      // onClick: () => props.setscheduleEmailCancelModal(true),
      icon: <EditPencilIcon color="#64748B" />,
      key: "EDIT",
    },
    {
      label: "Delete",
      icon: <DeleteIcon size="20" />,
      key: "DELETE",
      danger: true,
      onClick: e => {
        e.domEvent.stopPropagation();
        setdeleteModal(true);
      },
    },
  ];
  const { loading, refetch: refetchDrafts } = useQuery(GET_DRAFTS, {
    variables: {
      companyId: user.company.id,
      userId: user.id,
      locationId: sessionStorage.getItem("currentLocationId"),
      draftType: "EMAIL",
    },
    onCompleted: res => {
      setDrafts({ drafts: res.getDrafts.data, count: res.getDrafts.count });
    },
  });
  const fetchData = async (files, fileType) => {
    // @ts-ignore
    if (fileType.includes("video" || "quicktime")) {
      try {
        const response = await generateVideoThumbnails(files, 2);
        // setVideoThumbnails(response[0]);
        const thumbnailUrl = await s3uploader(
          response,
          process.env.GATSBY_S3_BUCKET,
          // @ts-ignore
          // @ts-ignore
          state => {},
          true,
          sessionStorage.getItem("currentLocationId")?.includes(",")
            ? "all"
            : sessionStorage.getItem("currentLocationId"),
          user,
          null
        );
        // @ts-ignore
        return thumbnailUrl.url;
      } catch (e) {
        console.log("DraftsJSX:Unable to generate video thumbnails", e);
      }
    }
  };
  const [deleteDraft] = useMutation(DELETE_DRAFT);
  const deleteDraftFn = async id => {
    // TODO: Implement Discard Draft here
    const res = await deleteDraft({
      variables: {
        id,
      },
    });
    if (res.data.deleteDraft.statusCode === 200) {
      message.success(res.data.deleteDraft.message);
      const refetchRes = await refetchDrafts();
      setDrafts({
        drafts: refetchRes.data.getDrafts.data,
        count: refetchRes.data.getDrafts.count,
      });
    } else {
      message.error(res.data.deleteDraft.message);
    }
  };
  const [createEmail, { loading: emailLoader }] = useMutation(CREATE_EMAIL);
  const handleEmail = async (values, emailTextRef) => {
    if (isEmpty(emailTextRef.current.innerText.replace(/\s/g, ""))) {
      return message.error("Please enter a body");
    }
    let mmsArr = [];
    if (attachments.length > 0) {
      mmsArr = await handleFiles(attachments, user, null, fetchData, props.setMediaUploadLoader);
    }
    const payload = {
      ...values,
      content: emailTextRef.current.innerHTML,
      userId: user.id,
      leadId: +draftMode.emailData.lead.id,
    };
    const res = await createEmail({
      variables: {
        ...payload,
        attachments: mmsArr,
      },
    });
    if (res.data.createEmail.statusCode === 200) {
      message.success(res.data.createEmail.message);
      deleteDraftFn(draftMode.emailData.id);
      setDraftMode({ visible: false });
    }
  };

  useEffect(() => {
    if (draftMode.visible && draftMode.emailData) {
      setTimeout(() => {
        emailForm.setFieldsValue({
          subject: draftMode.emailData.subject || "",
          to: draftMode.emailData.receiver || "",
        });

        if (emailTextRef.current && draftMode.emailData.body) {
          emailTextRef.current.innerHTML = draftMode.emailData.body;
        }
      }, 300);
    }
  }, [draftMode.visible, draftMode.emailData]);

  return (
    <div className="flex-col-centered w-full">
      <div className="email-scroll-container">
        {drafts?.drafts?.map((email, index) => (
          <div
            key={index}
            className="w-full min-h-min cursor-pointer"
            onClick={() => {
              setDraftMode({
                email: email.receiver,
                visible: true,
                body: email.body,
                emailData: email,
              });
            }}
          >
            <EmailCollapsedCard
              timeStampIcon={<Image preview={false} src={CLOCK_ICON} />}
              {...props}
              dropDownMenu={dropDownMenu}
              email={{ ...email, to: email.receiver }}
            />
          </div>
        ))}
      </div>
      <CancelScheduleConfirmation
        open={deleteModal}
        setOpen={setdeleteModal}
        cancelText="No"
        okText="Yes, Delete"
        description="Are you sure you want to delete this draft email?"
        title="Delete Draft"
      />
      <Drawer
        width="40%"
        open={draftMode.visible}
        onClose={() => setDraftMode({ email: "", visible: false, emailData: {} })}
        afterOpenChange={open => {
          if (!open) {
            emailForm.resetFields();
            if (emailTextRef.current) {
              emailTextRef.current.innerHTML = "";
            }
          }
        }}
      >
        <EmailTextWithBottom
          email={draftMode.email}
          setemail={value => setDraftMode({ ...draftMode, email: value })}
          attachments={attachments}
          body={draftMode.body}
          setattachments={setattachments}
          emailForm={emailForm}
          disableToEmail={!isEmpty(draftMode.email)}
          handleEmail={handleEmail}
          emailTextRef={emailTextRef}
          className="h-[58vh]"
        />
      </Drawer>
    </div>
  );
};
const TrashJSX = props => {
  const [deleteModal, setdeleteModal] = useState({ open: false, mode: "DELETE" });
  const [selectedMails, setselectedMails] = useState([]);
  const [viewEmailDrawer, setViewEmailDrawer] = useState({ open: false, email: {} });
  /**
   * @type {[import("./emailMockData").EmailsData[],import("react").Dispatch<import("react").SetStateAction<import("./emailMockData").EmailsData[]>>]}
   */
  // @ts-ignore
  const [emails, setemails] = useState([]);

  const {
    data,
    loading: getEmailsLoader,
    refetch: refetchEmails,
  } = useQuery(GET_EMAILS, {
    variables: {
      isDeleted: true,
    },
    fetchPolicy: "network-only",
    onCompleted: res => {
      setemails(res?.getEmails?.data || []);
    },
  });
  const handleRefetch = async () => {
    const res = await refetchEmails();
    setemails(res?.data?.getEmails?.data);
  };
  const [updateEmailStatus, { loading: updateStatusLoader }] = useMutation(UPDATE_EMAIL_STATUS);
  const dropDownMenu = email => [
    {
      label: "Delete",
      icon: <DeleteIcon size="20" />,
      danger: true,
      onClick: e => {
        e.domEvent.stopPropagation(); // Prevent outer click
        setdeleteModal({ open: true, mode: "DELETE" });
        setselectedMails([email.sesMessageId]);
      },
    },
    {
      label: "Restore",
      icon: <RestoreArchiveIcon size="20" />,
      key: "Restore",
      onClick: e => {
        e.domEvent.stopPropagation(); // Prevent outer click
        setdeleteModal({ open: true, mode: "RESTORE" });
        setselectedMails([email.sesMessageId]);
      },
    },
  ];
  const handleOk = async () => {
    const res = await updateEmailStatus({
      variables: {
        action: deleteModal.mode,
        sesMessageIds: selectedMails,
      },
    });
    if (res.data.updateEmailStatus.statusCode === 200) {
      message.success(res.data.updateEmailStatus.message);
      setselectedMails([]);
      handleRefetch();
      setdeleteModal({ open: false, mode: "DELETE" });
    } else {
      message.error(res.data.updateEmailStatus.message);
    }
  };
  return (
    <div className="flex-col-centered w-full">
      <div className="flex-row-centered items-center gap-2 py-3 px-4 border-0 border-b border-solid border-grey-200">
        <div>
          <Checkbox
            indeterminate={selectedMails.length > 0 && emails.length !== selectedMails.length}
            checked={selectedMails.length > 0 && selectedMails.length === emails.length}
            onChange={e => {
              if (e.target.checked) {
                // @ts-ignore
                setselectedMails(emails.map(m => m.sesMessageId));
              } else {
                setselectedMails([]);
              }
            }}
          />
        </div>
        <div className="flex-row-centered items-center">
          <Button.Group disabled={selectedMails.length === 0}>
            <Button
              disabled={selectedMails.length === 0}
              icon={<Image src={INBOX_ICON_1} preview={false} width={15} />}
              className="!text-grey-700"
              onClick={() => setdeleteModal({ mode: "RESTORE", open: true })}
            >
              Move to inbox
            </Button>
            <Button
              disabled={selectedMails.length === 0}
              className="!text-grey-700"
              icon={<Image className="!mb-1" width={15} preview={false} src={TRASH_ICON} />}
              onClick={() => setdeleteModal({ mode: "DELETE", open: true })}
            >
              Delete
            </Button>
          </Button.Group>
        </div>
      </div>
      <Spin spinning={getEmailsLoader} tip="Loading deleted emails...">
        <div className="email-scroll-container">
          {emails?.map((email, index) => {
            return (
              <div
                key={index}
                className="w-full min-h-min cursor-pointer"
                onClick={e => {
                  if (!e.target.closest(".ant-checkbox-wrapper")) {
                    setViewEmailDrawer({ open: true, email });
                  }
                }}
              >
                <EmailCollapsedCard
                  timeStampIcon={<EmailIcon size="16px" color="#334155" />}
                  {...props}
                  prefixNode={
                    <Checkbox
                      onChange={e => {
                        e.stopPropagation();
                        if (!e.target.checked) {
                          // @ts-ignore
                          setselectedMails(prev => {
                            // @ts-ignore
                            return prev.filter(m => m !== email.sesMessageId);
                          });
                        } else {
                          // @ts-ignore
                          setselectedMails(prev => [...prev, email.sesMessageId]);
                        }
                      }}
                      // @ts-ignore
                      checked={selectedMails.includes(email.sesMessageId)}
                    />
                  }
                  // @ts-ignore
                  selected={selectedMails.includes(email.sesMessageId)}
                  dropDownMenu={dropDownMenu(email)}
                  email={email}
                />
              </div>
            );
          })}
        </div>
      </Spin>
      <CancelScheduleConfirmation
        open={deleteModal.open}
        setOpen={value => setdeleteModal({ open: false, mode: "DELETE" })}
        cancelText="No"
        okText={`Yes, ${capitalize(deleteModal.mode)}`}
        description={`Are you sure you want to ${capitalize(deleteModal.mode)} this trash email?`}
        title={`${capitalize(deleteModal.mode)} Trash`}
        onOk={handleOk}
        loading={updateStatusLoader}
      />
      <Drawer
        width="40%"
        open={viewEmailDrawer.open}
        onClose={() => setViewEmailDrawer({ email: {}, open: false })}
        title={`Deleted email to ${viewEmailDrawer.email.to}`}
      >
        <ViewOnlyEmail email={viewEmailDrawer.email} />
      </Drawer>
    </div>
  );
};
/**
 *
 * @param {{email:import("./emailMockData").EmailsData,selected:boolean,prefixNode:import("react").ReactNode,timeStampIcon:import("react").ReactNode,dropDownMenu:[],showBody?:boolean}} props
 * @returns
 */
const EmailCollapsedCard = props => {
  const toDetails = `To: ${props.email?.lead?.fullName} <${props?.email?.to}>`;

  return (
    <div className="grid grid-cols-[25%_55%_10%] bg-grey-50 lg:grid-cols-[20%_65%_10%] items-center gap-4 p-4 border border-b border-x-0 border-t-0 border-grey-200 border-solid overflow-hidden">
      {/* First Column: Email Contact Details */}
      <div className="flex items-center gap-3 truncate">
        {props.prefixNode}
        <Avatar className="bg-gray-700 !min-w-8 !min-h-8">
          {convertToInitials(props.email.to)}
        </Avatar>
        <div className="flex flex-col truncate">
          <Tooltip title={toDetails}>
            <span className="text-sm font-normal text-gray-700 truncate">{toDetails}</span>
          </Tooltip>
          <span className="text-xs text-gray-700 flex items-center gap-1 truncate">
            {props.timeStampIcon}
            {convertUtcToLocal(
              props.email.latestActivityTs || props.email.updateTs,
              "DD MMM, YYYY, hh:mm A"
            )}
          </span>
        </div>
      </div>

      {/* Second Column: Email Subject and Body */}
      <div className="flex flex-col gap-1 truncate">
        <span className="text-sm font-normal text-gray-700 truncate">
          {props.email.subject || "(No Subject)"}
        </span>
        <span className="text-sm text-gray-700 truncate">
          {cleanHtmlForPreview(props?.email?.body || props?.email?.bodyHtml, 200)}
        </span>
      </div>

      {/* Third Column: Dropdown Menu */}
      <div className="flex justify-end">
        <Dropdown
          menu={{
            items: props.dropDownMenu,
          }}
          trigger={["click"]}
        >
          <MoreOutlined onClick={e => e.stopPropagation()} className="cursor-pointer" />
        </Dropdown>
      </div>
    </div>
  );
};
// @ts-ignore
// @ts-ignore
/**
 * @param {{company?:{},isAdmin?:boolean}} props
 */
export const EmailTemplateJSX = props => {
  const { isAdmin = false } = props;
  const { user } = useContext(UserContext);
  const [deleteModal, setdeleteModal] = useState({ open: false, record: null });
  const [emailTemplates, setemailTemplates] = useState([]); // State for email templates
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // State for selected rows
  const [email, setemail] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // State for search term
  const [emailForm] = Form.useForm();
  const emailTextRef = useRef(null);
  const [attachments, setattachments] = useState([]);
  const [drawerTemplate, setdrawerTemplate] = useState({
    mode: "ADD",
    open: false,
    record: null, // Add record to track the selected template
  });

  const { loading: emailTemplateLoader, refetch: refetchEmailTemplates } = useQuery(
    GET_ENGAGEMENT_MESSAGE_TEMPLATES,
    {
      variables: {
        companyId: isAdmin ? +user.company.id : +props?.company?.id || +user.company.id,
        templateType: TEMPLATE_ENUMS.EMAIL,
        userId: +user.id,
        search: searchTerm, // Pass search term to the query
      },
      onCompleted: res => {
        setemailTemplates(res.engagementMessageTemplates || []); // Update state with fetched templates
      },
    }
  );

  const handleSearch = value => {
    setSearchTerm(value); // Update search term state
  };

  const handleRefetch = async () => {
    const res = await refetchEmailTemplates();
    setemailTemplates(res.data.engagementMessageTemplates || []); // Update state after refetch
  };

  const onSelectChange = selectedKeys => {
    setSelectedRowKeys(selectedKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleEdit = record => {
    setdrawerTemplate({
      mode: "EDIT",
      open: true,
      record,
    });

    // Use setTimeout to ensure refs and form are ready after Drawer opens
    setTimeout(() => {
      emailForm.setFieldsValue({
        title: record.title || "",
        subject: record.subject || "",
        sharedWith:
          record.isCompanyShared === true
            ? "COMPANY"
            : record.isCompanyShared === false
            ? "LOCATION"
            : "",
      });
      if (emailTextRef.current) {
        emailTextRef.current.innerHTML = record.message || "";
      }
    }, 0);
  };

  function ActiveToggle({ record }) {
    const [saveEngagementMessageTemplate, { loading: toggleLoader }] = useMutation(
      SAVE_ENAGEMENT_MESSAGE_TEMPLATE
    );
    const { user: userContext } = useContext(UserContext);

    return (
      <Switch
        size="small"
        checked={record?.isActive || false}
        loading={toggleLoader}
        onChange={async checked => {
          try {
            const res = await saveEngagementMessageTemplate({
              variables: {
                userId: +userContext.id,
                companyId: +userContext.company.id,
                id: +record.id,
                title: record.title,
                message: record.message,
                isActive: checked,
                isCompanyShared: record.isCompanyShared,
                locationId: +record?.location?.id,
                subject: record.subject,
                templateType: record.templateType,
              },
            });

            if (res.data.saveEngagementMessageTemplate.statusCode === 200) {
              message.success(res.data.saveEngagementMessageTemplate.message);
              handleRefetch(); // Refetch the templates after mutation
            } else {
              message.error(res.data.saveEngagementMessageTemplate.message);
            }
          } catch (error) {
            message.error("Failed to toggle the template. Please try again.");
          }
        }}
      />
    );
  }

  const emailTemplateColumns = [
    {
      title: "Template Title",
      render: (text, record, index) => (
        <span className="text-brand-500 font-semibold" key={index}>
          {record?.title || ""}
        </span>
      ),
    },
    {
      title: "Owner",
      render: (text, record, index) => <span>{record?.user?.fullName || ""}</span>,
    },
    {
      title: "Shared with",
      render: (text, record, index) => (
        <span>{record?.isCompanyShared ? "Company" : "Location"}</span>
      ),
    },
    {
      title: "Actions",
      render: (text, record, index) => (
        <span key={index} className="flex-row-centered gap-4 items-center">
          <ActiveToggle record={record} />
          <EditPencilIcon
            onClick={() => handleEdit(record)} // Call handleEdit on edit button click
            className="cursor-pointer"
            color="#64748B"
          />
          <DeleteIcon
            className="cursor-pointer"
            onClick={() => setdeleteModal({ open: true, record })}
          />
        </span>
      ),
    },
  ];

  const [updateCompanyEmailTemplateEvent, { loading: emailTemplateEventLoader }] = useMutation(
    SAVE_ENAGEMENT_MESSAGE_TEMPLATE
  );

  const close = () => {
    // @ts-ignore
    emailTextRef.current.innerText = "";
    emailForm.resetFields();
    setdrawerTemplate({ open: false, mode: "ADD" });
  };

  const handleEmail = async (values, emailTextRef, emailTemplate) => {
    if (isEmpty(emailTextRef.current.innerText.replace(/\s/g, ""))) {
      return message.error("Please enter a body");
    }

    const { title, subject, sharedWith } = values;
    const templateText = emailTextRef.current.innerHTML;

    try {
      const res = await updateCompanyEmailTemplateEvent({
        variables: {
          id: drawerTemplate.mode === "EDIT" ? drawerTemplate.record.id : null, // Use the record ID for edit
          userId: +user.id,
          companyId: +user.company.id,
          title,
          message: templateText,
          isActive: drawerTemplate.mode === "EDIT" ? drawerTemplate.record.isActive : true,
          isCompanyShared: sharedWith === "COMPANY",
          locationId: +sessionStorage.getItem("currentLocationId"),
          subject,
          templateType: "EMAIL",
        },
      });

      if (res.data.saveEngagementMessageTemplate.statusCode === 200) {
        message.success(res.data.saveEngagementMessageTemplate.message);
        handleRefetch();
        close(); // Close the drawer after successful mutation
      } else {
        message.error(res.data.saveEngagementMessageTemplate.message);
      }
    } catch (error) {
      message.error("Failed to save the email template. Please try again.");
    }
  };

  const [deleteEngagementMessageTemplate, { loading: deleteTemplateLoader }] = useMutation(
    DELETE_ENAGEMENT_MESSAGE_TEMPLATE
  );

  const handleDeleteSelected = async () => {
    try {
      const res = await deleteEngagementMessageTemplate({
        variables: {
          engagementTemplateIds: selectedRowKeys.map(id => +id), // Convert IDs to numbers
          userId: +user.id,
        },
      });

      if (res.data.deleteEngagementMessageTemplate.statusCode === 200) {
        message.success(res.data.deleteEngagementMessageTemplate.message);
        handleRefetch(); // Refetch templates after deletion
        setSelectedRowKeys([]); // Clear selected rows
        setdeleteModal({ open: false, record: null }); // Close the modal
      } else {
        message.error(res.data.deleteEngagementMessageTemplate.message);
      }
    } catch (error) {
      message.error("Failed to delete the selected templates. Please try again.");
    }
  };

  const handleDeleteSingle = async record => {
    try {
      const res = await deleteEngagementMessageTemplate({
        variables: {
          engagementTemplateIds: [+record.id], // Single record ID
          userId: +user.id,
        },
      });

      if (res.data.deleteEngagementMessageTemplate.statusCode === 200) {
        message.success(res.data.deleteEngagementMessageTemplate.message);
        handleRefetch(); // Refetch templates after deletion
        setdeleteModal({ open: false, record: null }); // Close the modal
      } else {
        message.error(res.data.deleteEngagementMessageTemplate.message);
      }
    } catch (error) {
      message.error("Failed to delete the template. Please try again.");
    }
  };

  return (
    <div className="p-5 w-full">
      <div className="flex-row-centered gap-2 justify-between">
        <div className="flex-row-centered gap-2">
          <DebounceInput
            placeholder="Search Template"
            suffix={<SearchOutlined />}
            value={searchTerm}
            allowClear
            onChange={value => handleSearch(value)} // Call handleSearch on input change
          />
          <Button
            className="flex-row-centered disabled:!text-grey-700 !text-grey-700 gap-2 rounded"
            disabled={selectedRowKeys.length === 0} // Disable if no rows are selected
            onClick={() => setdeleteModal({ open: true })} // Open confirmation dialog
          >
            <DeleteIcon size="16px" />
            Delete
          </Button>
        </div>
        <Button
          type="primary"
          onClick={() =>
            setdrawerTemplate({
              open: true,
              mode: "ADD",
            })
          }
        >
          Create Template
        </Button>
      </div>
      <Table
        rowSelection={rowSelection} // Attach rowSelection to the table
        className="mt-2"
        rowKey={record => record?.id}
        dataSource={emailTemplates} // Data source for the table
        columns={emailTemplateColumns}
        loading={emailTemplateLoader}
        bordered
        pagination={false}
      />
      <CancelScheduleConfirmation
        open={deleteModal.open}
        setOpen={value => setdeleteModal({ open: value })}
        cancelText="No"
        okText="Yes, Delete"
        description={
          deleteModal.record
            ? "Are you sure you want to delete this template?" // Single delete description
            : "Are you sure you want to delete all the selected templates?" // Multiple delete description
        }
        title="Confirm Delete?"
        onOk={
          deleteModal.record
            ? () => handleDeleteSingle(deleteModal.record) // Handle single delete
            : handleDeleteSelected // Handle multiple delete
        }
        loading={deleteTemplateLoader}
      />
      <TemplateDrawer
        drawerTemplate={drawerTemplate}
        close={close}
        emailForm={emailForm}
        email={email}
        setemail={setemail}
        attachments={attachments}
        setattachments={setattachments}
        handleEmail={handleEmail}
        emailTextRef={emailTextRef}
        loading={emailTemplateEventLoader}
      />
    </div>
  );
};
/**
 *
 * @param {{open:boolean,setOpen:import("react").Dispatch<import("react").SetStateAction<boolean>>,title:string,okText:import("react").ReactNode,cancelText:import("react").ReactNode, onOk:()=>any,description:string,loading?:boolean}} props
 * @returns
 */
export const CancelScheduleConfirmation = props => {
  const handleCancel = () => props.setOpen(false);

  return (
    <Modal
      title={props.title}
      open={props.open}
      onCancel={handleCancel}
      footer={
        <div className="flex-row-centered justify-start items-center gap-2">
          <Button
            type="primary"
            className="!p-3"
            danger
            loading={props.loading} // Show loader during operation
            onClick={props.onOk} // Handle confirmation action
          >
            {props.okText}
          </Button>
          <Button className="!p-3" onClick={handleCancel}>
            {props.cancelText}
          </Button>
        </div>
      }
    >
      <span>
        {props.description || // Use dynamic description if provided
          (props.isMultiple
            ? "Are you sure you want to delete all the selected templates?"
            : "Are you sure you want to delete this template?")}
      </span>
    </Modal>
  );
};
function TemplateDrawer({
  drawerTemplate,
  close,
  emailForm,
  email,
  setemail,
  attachments,
  setattachments,
  handleEmail,
  emailTextRef,
  loading,
}) {
  useEffect(() => {
    if (drawerTemplate.open && drawerTemplate.mode === "EDIT" && drawerTemplate.record) {
      emailForm.setFieldsValue({
        title: drawerTemplate.record.title || "",
        subject: drawerTemplate.record.subject || "",
        sharedWith:
          drawerTemplate.record.isCompanyShared === true
            ? "COMPANY"
            : drawerTemplate.record.isCompanyShared === false
            ? "LOCATION"
            : "",
      });
      if (emailTextRef.current) {
        emailTextRef.current.innerHTML = drawerTemplate.record.message || "";
      }
    }
    if (!drawerTemplate.open) {
      emailForm.resetFields();
      if (emailTextRef.current) emailTextRef.current.innerHTML = "";
    }
  }, [drawerTemplate.open, drawerTemplate.mode, drawerTemplate.record, emailForm, emailTextRef]);

  const handleSave = async () => {
    try {
      const values = await emailForm.validateFields();
      await handleEmail(values, emailTextRef, email);
      emailForm.resetFields();
      if (emailTextRef.current) emailTextRef.current.innerHTML = "";
      setattachments([]);
      close();
    } catch (err) {
      // Validation error, do nothing (AntD will show errors)
    }
  };

  return (
    <Drawer
      open={drawerTemplate.open}
      title={drawerTemplate.mode === "ADD" ? "Create Template" : "Edit Template"}
      width="40%"
      onClose={close}
      footer={
        <div className="flex-row-centered w-full items-center">
          <div className="flex-row-centered gap-1">
            <Button type="primary" loading={loading} onClick={handleSave} icon={<SendIcon />}>
              Save
            </Button>
            <Button onClick={close}>Cancel</Button>
          </div>
        </div>
      }
    >
      <Form form={emailForm} layout="vertical">
        <div className="flex-row-centered gap-2">
          <Form.Item
            name="title"
            className="w-3/4"
            label="Template Name"
            rules={[{ required: true, message: "Template name is required" }]}
          >
            <Input placeholder="Write a template name" name="title" />
          </Form.Item>
          <Form.Item
            className="w-1/4"
            name="sharedWith"
            label="Shared With"
            rules={[{ required: true, message: "Shared With is required" }]}
          >
            <Select
              name="sharedWith"
              placeholder="Select"
              options={[
                { label: "Company", value: "COMPANY" },
                { label: "Location", value: "LOCATION" },
                { label: "User", value: "USER" },
              ]}
            />
          </Form.Item>
        </div>
        {/* subject is handled in EmailTextBox */}
      </Form>
      <EmailTextWithBottom
        className="h-[50vh]"
        email={email}
        setemail={setemail}
        attachments={attachments}
        setattachments={setattachments}
        showTo={false}
        showSend={false}
        emailForm={emailForm}
        handleEmail={handleEmail}
        emailTextRef={emailTextRef}
      />
    </Drawer>
  );
}

function EmailTextWithBottom({
  email,
  setemail,
  attachments,
  setattachments,
  className = "",
  showTo = true,
  showSend = true,
  showSubject = true,
  emailForm,
  handleEmail,
  emailTextRef,
  body = "",
  disableToEmail = false,
  leadId = null,
  setEmailBody = () => {},
}) {
  const [emailCursor, setemailCursor] = useState(null);
  const mediaRef = useRef(null);
  const videoRef = useRef(null);
  const documentRef = useRef(null);
  const handleMediaSharing = mediaType => {
    if (mediaType === "image") {
      // @ts-ignore
      mediaRef.current.click();
    } else if (mediaType === "video") {
      // @ts-ignore
      videoRef.current.click();
    } else {
      // @ts-ignore
      documentRef.current.click();
    }
  };
  /**
   *
   * @param {string} signature
   */
  const addSignature = signature => {
    // @ts-ignore
    emailTextRef.current.innerHTML = `${emailTextRef.current.innerHTML} <br/> ${signature}`;
  };
  const totalSize = useMemo(() => {
    return sumBy(
      // @ts-ignore
      attachments.map(item => item.file),
      "size"
    );
  }, [attachments]);

  return (
    <div
      className="flex-col-centered border-grey-200 rounded-md p-1 border border-1"
      id="email-text-box-container"
    >
      {attachments.length > 0 && (
        <div className="w-full">
          <Collapse
            className="reverse-collapse transparent-collapse border-none"
            defaultActiveKey={["1"]}
            accordion
          >
            {attachments.length > 0 && (
              <Collapse.Panel
                key="1"
                header={
                  <div className="flex-row-centered gap-0.5 items-center justify-between">
                    <div className="flex-row-centered gap-0.5 items-center">
                      <span className="text-xs font-[600] text-grey-700">
                        {attachments.length} attachment
                      </span>
                      <i className="text-xs font-[400] text-grey-700">
                        {" "}
                        <span className="my-1  flex flex-row items-center gap-1 ">
                          ({formatBytes(totalSize)})
                        </span>
                      </i>
                    </div>
                    <span
                      className="text-red-500 text-xs font-[600] cursor-pointer"
                      onClick={e => {
                        e.stopPropagation();
                        setattachments([]);
                      }}
                    >
                      Remove all
                    </span>
                  </div>
                }
              >
                <Attachments
                  key="email-attachments"
                  attachments={attachments}
                  setAttachments={setattachments}
                />
              </Collapse.Panel>
            )}
          </Collapse>
        </div>
      )}
      <EmailTextBox
        emailTextRef={emailTextRef}
        setEmailCursor={value => setemailCursor(value)}
        textDisabled={() => false}
        email={email}
        setemail={setemail}
        emailMode="edit"
        emailForm={emailForm}
        handleEmail={value => handleEmail(value, emailTextRef, email)}
        className={className}
        showTo={showTo}
        showSubject={showSubject}
        disableToEmail={disableToEmail}
        body={body}
      />
      <EmailBottomActions
        attachments={attachments}
        // @ts-ignore
        setAttachments={setattachments}
        documentRef={documentRef}
        mediaRef={mediaRef}
        videoRef={videoRef}
        buttonDisabled={() => false}
        emailTextRef={emailTextRef}
        handleMediaSharing={handleMediaSharing}
        emailCursor={emailCursor}
        emailForm={emailForm}
        addSignature={addSignature}
        showSend={showSend}
        setEmailCursor={setemailCursor}
        leadId={leadId}
        setEmailBody={setEmailBody}
        body={emailTextRef?.current?.innerHTML}
      />
    </div>
  );
}
